import React from 'react';

import UserDetailsContext from './UserDetailsContext';
import useUserDetailsProvider from './useUserDetailsProvider';

const UserDetailsProvider: React.FC<{}> = ({ children }) => {
	const { selectedUser, userSearchDetails, setUserSearchDetails, setSelectedUser, handleParseUserDetails } =
		useUserDetailsProvider();

	return (
		<UserDetailsContext.Provider
			value={{
				selectedUser,
				userSearchDetails,
				setUserSearchDetails,
				handleParseUserDetails,
				setSelectedUser
			}}>
			{children}
		</UserDetailsContext.Provider>
	);
};

export default UserDetailsProvider;
